import React from 'react';
import PropTypes from 'prop-types';

import AppLink from 'components/App/AppLink';

import { CURRENCY_LABEL, LOCATIONS } from 'constants/index';
import FinancePropTypes from 'propTypeModels/finance';
import { convertIsoDateToString } from 'utils';
import { currencyFormat } from 'utils/currencyFormat';

import styles from './FananceDataTableInvoice.module.scss';

function FananceDataTableInvoice({ finances, placeId }) {
  return (
    <div className={styles.Component}>
      {finances.length === 0 ? (
        <div className={styles.NoData}>Chưa có dữ liệu</div>
      ) : (
        <table className={styles.Table}>
          <thead>
            <tr>
              <th>Ngày thanh toán</th>
              <th>Mã hoá đơn</th>
              <th>Tổng tiền</th>
              <th>Trạng thái</th>
              <th aria-label="Xem chi tiết" />
            </tr>
          </thead>

          <tbody>
            {finances.map((item) => (
              <tr key={item._id}>
                <td>{convertIsoDateToString(item.createdAt)}</td>

                <td>{`#${item.invoiceCode}`}</td>

                <td>
                  <strong>
                    {currencyFormat({
                      currency: CURRENCY_LABEL,
                      value: item.totalAmount || 0,
                    })}
                  </strong>
                </td>

                <td className={styles.RemittanceStatus}>
                  {item.isPaid ? 'Đã thanh toán' : 'Chưa thanh toán'}
                </td>

                <td>
                  <AppLink
                    href={`${LOCATIONS.LOCATION_DETAIL.FINANCE_DETAIL.replace(':id', item._id)}?place=${placeId}`}
                    className={styles.DetailLink}
                  >
                    Xem chi tiết
                  </AppLink>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

FananceDataTableInvoice.propTypes = {
  finances: PropTypes.arrayOf(FinancePropTypes.invoiceEntity.isRequired)
    .isRequired,
  placeId: PropTypes.string,
};

FananceDataTableInvoice.defaultProps = {
  placeId: '',
};

export default React.memo(FananceDataTableInvoice);
